import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import surveys from './modules/surveys'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {},
	mutations: {},
	actions: {},
	modules: {
		user,
		surveys
	}
})
